var alignment_rtlignore_default = {
  "alignLeft": "UMHP1",
  "textWrapNowrap": "wjg73",
  "alignRight": "AZop2",
  "alignCenter": "XNykp",
  "sizeFullWidth": "mfyvn",
  "renderedInTable": "YfTw5",
  "sizeOriginal": "_0Jdvd",
  "sizeContent": "yiL0I",
  "sizeSmall": "LKadf",
  "sizeSmallCenter": "xWrFP",
  "flex": "IVrSJ",
  "LEFT": "ZmDVx",
  "CENTER": "OiC3A",
  "RIGHT": "dJ-zP",
  "AUTO": "ypcKa",
  "JUSTIFY": "i0w2X"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
